import React, { useContext, useEffect } from 'react';
import { UserContext } from '../context/UserContext';
import { redirectToLogin } from '@redpanda/auth-utils';
import { IDENTITY_SERVICE_URL } from '../constants/publicPaths';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useContext(UserContext)!;

  // 已認證（含 localStorage 快取）→ 直接渲染；未認證 → 導向登入
  const allowed = isAuthenticated && (isLoading || !!user);

  // 導向放在 effect：渲染中不做副作用（StrictMode、重新渲染時不會重複觸發）
  useEffect(() => {
    if (!allowed) redirectToLogin(IDENTITY_SERVICE_URL, window.location.href);
  }, [allowed]);

  return allowed ? <>{children}</> : null;
};

export default PrivateRoute;
